__turbopack_context__.v({
  "ArrowIconButton": "pagination-module__pHyUmW__ArrowIconButton",
  "PageButton": "pagination-module__pHyUmW__PageButton",
  "PageButtonActive": "pagination-module__pHyUmW__PageButtonActive",
  "PageButtonInactive": "pagination-module__pHyUmW__PageButtonInactive",
  "StyledIconButton": "pagination-module__pHyUmW__StyledIconButton",
});
